export function getImgixUrl(url) {
    if (url) {
        // tslint:disable-next-line:max-line-length
        return url.replace(/stable\.web\.blog-backend\.(qa|staging|production)\.lonelyplanet\.com\/wp-content\/uploads\//g, "lonelyplanetimages.imgix.net/blog/$1/")
            .replace(/media\.lonelyplanet\.com\/blog\/(qa|staging|production)\//g, "lonelyplanetimages.imgix.net/blog/$1/");
    }
    return null;
}



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/utils/getImgixUrl.tsx
// module id = 4249
// module chunks = 3